import { render, staticRenderFns } from "./IndexDetail.vue?vue&type=template&id=e2fed00e&scoped=true"
import script from "./IndexDetail.vue?vue&type=script&lang=js"
export * from "./IndexDetail.vue?vue&type=script&lang=js"
import style0 from "./IndexDetail.vue?vue&type=style&index=0&id=e2fed00e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fed00e",
  null
  
)

export default component.exports